import { Component, inject } from '@angular/core';
import { ClosingStageStatusParametersService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ClosingStageStatusParametersCreateDto,
  ClosingStageStatusParametersDto,
  ClosingStageStatusParametersExcelDownloadDto,
  ClosingStageStatusParametersUpdateDto,
} from '../proxy/controlling/dtos/closing-stage-status-parameters';
import { CLOSINGSTAGESTATUSPARAMETERS_CONFIG, CLOSINGSTAGESTATUSPARAMETERS_FIELDS } from './closing-stage-status-parameters.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-closing-stage-status-parameters',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ClosingStageStatusParametersService, ConfirmationService],
  templateUrl: './closing-stage-status-parameters.html',
  styleUrl: './closing-stage-status-parameters.scss',
})
export class ClosingStageStatusParameters extends BaseCrudComponent<
  ClosingStageStatusParametersDto,
  ClosingStageStatusParametersCreateDto,
  ClosingStageStatusParametersUpdateDto,
  ClosingStageStatusParametersExcelDownloadDto
> {
  service = inject(ClosingStageStatusParametersService);
  config = CLOSINGSTAGESTATUSPARAMETERS_CONFIG;
  fields = CLOSINGSTAGESTATUSPARAMETERS_FIELDS;

  protected prepareUpdateDto(data: any, selected: ClosingStageStatusParametersDto): ClosingStageStatusParametersUpdateDto {
    return {
      stageId: data.stageId,
      minimumAdjustmentReasonId: data.minimumAdjustmentReasonId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ClosingStageStatusParameters';
  }
}
